@if (notificationType == 'info') {
  <div [class.lm-notification-visible]="isVisible"
    class="notification info lm-notification-container">
    <p
      class="notification-text"
      >{{message}}
      @if (actionMessage) {
        <a
          class="notification-link"
        (click)="handleActionClick()">{{actionMessage}}</a>
      }
    </p>
    <button
      type="text"
      soho-button [icon]="'close'"
      class="notification-close lm-notification-close-btn "
    (click)="handleClose()"></button>
  </div>
}

@if (notificationType == 'success') {
  <div [class.lm-notification-visible]="isVisible"
    class="notification success lm-notification-container">
    <p
      class="notification-text"
      style="flex-:1 wrap">{{message}}
      @if (actionMessage) {
        <a
          class="notification-link"
        (click)="handleActionClick()">{{actionMessage}}</a>
      }
    </p>
    <button
      type="text"
      soho-button [icon]="'close'"
      class="notification-close lm-notification-close-btn "
    (click)="handleClose()"></button>
  </div>
}

@if (notificationType == 'alert') {
  <div [class.lm-notification-visible]="isVisible"
    class="notification alert lm-notification-container">
    <p
      class="notification-text"
      style="flex-:1 wrap">{{message}}
      @if (actionMessage) {
        <a
          class="notification-link"
        (click)="handleActionClick()">{{actionMessage}}</a>
      }
    </p>
    <button
      type="text"
      soho-button [icon]="'close'"
      class="notification-close lm-notification-close-btn "
    (click)="handleClose()"></button>
  </div>
}

@if (notificationType == 'error') {
  <div [class.lm-notification-visible]="isVisible"
    class="notification error lm-notification-container">
    <p
      class="notification-text"
      style="flex-:1 wrap">{{message}}
      @if (actionMessage) {
        <a
          class="notification-link"
        (click)="handleActionClick()">{{actionMessage}}</a>
      }
    </p>
    <button
      type="text"
      soho-button [icon]="'close'"
      class="notification-close lm-notification-close-btn "
    (click)="handleClose()"></button>
  </div>
}
